/**
 * @fileoverview Own cross-explorer copy/cut intent and paste request construction. Clipboard entries retain document/folder identity; a consumed cut token prevents the same local move intent from being reused. The executing workspace/backend owns validation and actual location changes. Browser clipboard state is an operation proposal rather than canonical storage state.
 */

const PREFIX = 'kc-documents-clipboard:v1\n';
const CONSUMED_CUT_KEY = 'kc.documents.clipboard.consumed-cut';



export function encodeDocumentClipboard(action, selection) {
  return PREFIX + JSON.stringify({
    origin: window.location.origin,
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    action,
    selection,
  });
}



export function decodeDocumentClipboard(text) {
  if (!text?.startsWith(PREFIX)) return null;
  try {
    const value = JSON.parse(text.slice(PREFIX.length));
    if (value.origin !== window.location.origin || !value.id || !['copy', 'move'].includes(value.action)) return null;
    const selection = value.selection;
    if (!selection || !['items', 'query'].includes(selection.mode)) return null;
    if (selection.mode === 'items' && (!Array.isArray(selection.items) || !selection.items.length ||
      selection.items.some(item => !['document', 'folder'].includes(item?.item_type) || typeof item.item_id !== 'string' || !item.item_id))) return null;
    if (value.action === 'move' && window.localStorage.getItem(CONSUMED_CUT_KEY) === value.id) return null;
    return value;
  } catch (_error) {
    return null;
  }
}



export function consumeDocumentCut(value) {
  if (value.action !== 'move') return;
  try {
    window.localStorage.setItem(CONSUMED_CUT_KEY, value.id);
  } catch (_error) {
    // The server still validates the source's expected update timestamp.
  }
}



export async function readDocumentClipboard() {
  if (navigator.clipboard?.readText) {
    return decodeDocumentClipboard(await navigator.clipboard.readText());
  }
  throw new Error('Use Ctrl+V or ⌘V to paste from the clipboard.');
}



export function isClipboardEditingTarget(target) {
  return Boolean(target?.closest?.('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="dialog"], [aria-modal="true"]'));
}
